export const CATEGORIES_LIST_KEY = 'CATEGORIES_LIST';
export const CATEGORIES_LIST_CLEAN = 'CATEGORIES_LIST_CLEAN';
export const CATEGORIES_ONE_KEY = 'CATEGORIES_ONE_KEY';
